module.exports = __webpack_public_path__ + "img/700_Social-media-sharing.d44675ea.png";